var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1920",
    enableBackground: "new 0 0 1920 1920",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#8A92B2",
    points: "959.8,80.7 420.1,976.3 959.8,731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62688F",
    points: "959.8,731 420.1,976.3 959.8,1295.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62688F",
    points: "1499.6,976.3 959.8,80.7 959.8,731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#454A75",
    points: "959.8,1295.4 1499.6,976.3 959.8,731  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8A92B2",
    points: "420.1,1078.7 959.8,1839.3 959.8,1397.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#62688F",
    points: "959.8,1397.6 959.8,1839.3 1499.9,1078.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthLogo);
export default __webpack_public_path__ + "static/media/eth_logo.364436c59a4c4158edfcf97317880e66.svg";
export { ForwardRef as ReactComponent };